<template>
  <div class="nuttrema-index-list-header">
    <resize-observer @notify="onResize"></resize-observer>
    <div class="nuttrema-index-list-header__content" ref="content">
      <div v-if="loading" class="nuttrema-index-list-header__content__loader">
        <p class="loading-dot-blink">{{ $t('label.loading') }} <span>.</span><span>.</span><span>.</span></p>
      </div>
      <slot v-else></slot>
    </div>
  </div>
</template>

<script>
import { ResizeObserver } from 'vue-resize';

export default {
  name: 'nuttrema-index-list-header',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ResizeObserver,
  },
  data() {
    return {
      collapsed: false,
      timeout: false,
      delay: 350,
    };
  },
  methods: {
    onResize() {
      this.$nextTick(() => {
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(() => {
          this.compareWidth();
        }, this.delay);
      });
    },
    compareWidth() {
      const content = this.$refs.content;
      const contentWidth = content.scrollWidth - (2 * 10);
      const childNodes = content.childNodes;

      console.log('resize-observer triggered!', content);

      let childsWidth = 0;
      for (let i = childNodes.length - 1; i >= 0; i -= 1) {
        if (childNodes[i].scrollWidth) {
          childsWidth += childNodes[i].scrollWidth + 12;
        }
      }

      console.log('compare', contentWidth, childsWidth);
      this.collapsed = childsWidth >= contentWidth;
    },
  },
  watch: {
    loading(value, old) {
      this.$nextTick(() => {
        if (value !== old) {
          this.onResize();
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.onResize();
    });
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-index-list-header {
    flex-grow: 1;
    display: flex;
    padding: 10px 1em;
    align-self: stretch;
    flex-direction: column;
    justify-content: flex-start;

    .nuttrema-index-list-header__content {
      flex-grow: 1;
      display: flex;
      overflow-x: hidden;
      align-items: center;
      align-self: stretch;

      > * {
        flex-shrink: 0;
        margin-right: 12px;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/list/nuttrema-index-list-header.vue